import { useMemo } from 'react';
import { useWebsiteStattistic } from '..';

const useTopProductInCart = () => {
  const { data } = useWebsiteStattistic();

  const topProductInCart = useMemo(() => {
    if (Array.isArray(data?.top_product_incart)) {
      return data.top_product_incart;
    }

    return [];
  }, [data?.top_product_incart]);

  const columns = useMemo(() => {
    return [
      {
        title: 'Tên',
        render: (_, record) => `${record?.product?.name || ''} ${record?.variant?.variant_title || ''}`.trim(),
      },
      {
        title: 'Số lượng',
        render: (_, record) => record?.quantity,
      },
    ];
  }, []);

  return {
    columns,
    dataSource: topProductInCart,
  };
};

export default useTopProductInCart;
